import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, message } from 'antd';
import {finish3DCollection} from '../../redux/actions/3DCollection/finish3DCollection';
import {toggleFinishModal} from '../../redux/actions/3DCollection/toggleFinishModal';

class Finish3DCollectionModal extends React.Component {
    constructor(props){
        super(props);
        this.form=React.createRef();
    }
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };
    onFinish = async (values) => {
        await this.props.onFinish({collectionId:this.props.collectionId,...values},this.props.token);
        if(this.props.message){
            message.success(this.props.message);
            this.props.onClose();
        }
        if(this.props.error){
            message.error(this.props.error);
        }
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Finish 3D Collection"
                key="finish-3d-c"
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'finish-3d-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="finish-3d-form"
                    {...this.layout}
                    name="basic"
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                   
                    <Form.Item
                        name="threeDNumber"
                        label="Three D Number"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                    >
                        <Input type="number"/>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.threeDCollection.finishVisible,
    loading: state.threeDCollection.loading,
    token: state.auth.token,
    error:state.threeDCollection.error,
    message:state.threeDCollection.message,
    collectionId:state.threeDCollection.collectionId
})

const mapDispatchToProps = dispatch => ({
    onFinish: (obj, token) => dispatch(finish3DCollection(obj, token)),
    onClose: () => dispatch(toggleFinishModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Finish3DCollectionModal);